import React, { Component } from 'react'
import { Button, Popup, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import "../Toolbar.css";

class IntegrationSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleForm = (e) => {
        dispatch.platform.setIntegrationModal(true)
        dispatch.platform.setIntegrationModalType("add")
    }

    render() {
        return (
            this.props.mainAreaContext === "Integration" && <div className="toolBar header_buttons">
                <Button.Group size='mini' >
                    <Popup className="popupStyled"
                        inverted
                        trigger={<span><Button
                            icon='plus'
                            className="clr-green"
                            onClick={this.handleForm} />
                        </span>}
                        content='Create' />
                </Button.Group>
            </div>
        )
    }
}
export default IntegrationSetting

